import { ref, readonly } from 'vue'
import { ConfigService } from '@/services/Backend/Config'

const configService = new ConfigService()

const _passwordStrengthMinScore = ref(0)
const _loaded = ref(false)

export const config = {
    passwordStrengthMinScore: readonly(_passwordStrengthMinScore),
    loaded: readonly(_loaded),
}

export async function fetchConfig(): Promise<void> {
    const appConfig = await configService.fetchConfig()
    _passwordStrengthMinScore.value = appConfig.passwordStrengthMinScore
    _loaded.value = true
}
